import {createLogger, mapActions, mapGetters, mapMutations} from "vuex";
import { directive as onClickaway } from "vue-clickaway";
import _ from "lodash";
import { Carousel, Slide } from "vue-carousel";
import moment from "moment/moment";

export default {
    name: "basket",
    components: {
        Carousel,
        Slide,
    },
    data() {
        return {
            showPromo: false,
            isValidCode: false,
            codeValue: "",
        };
    },
    directives: {
        onClickaway: onClickaway,
    },
    // watch: {
    //   'basket'() {
    //     this.isDiscountPrice()
    //   }
    // },
    created() {
        this.changeBasket();
        this.fetchRecommendedList();
    },
    computed: {
        ...mapGetters({
            showBasket: "basket/showBasket",
            basket: "basket/basket",
            count: "basket/count",
            countBasketItems: "basket/countBasketItems",
            recommendedList: "recommendedProduct/recommendedList",
            recommendedListLength: "recommendedProduct/recommendedListLength",
            recommendedListLoading: "recommendedProduct/recommendedListLoading",
            orderResult: "basket/orderResult",
            promocodeLoading: "basket/promocodeLoading",
            promocodeStatus: "basket/promocodeStatus",
            enteredCode: "basket/enteredCode",
        }),
        checkAllProductCanUsePromocode() {
            return this.basket.some(item => !!item.apply_promocode);
        },
        checkShowPromo() {
            if (this.basket.length === 0) {
                return false;
            }
            return this.basket.some(product => !product.discount_price);
        },
        // apply_promocode
        amountWithDiscount() {
            return this.basket.reduce((sum, item) => {
                const price = item.discount_price || item.min_price;
                if (!item.apply_promocode) return sum + item.price * item.select_count;
                return sum + price * item.select_count;
            }, 0);
        },
        totalAmount() {
            return this.basket.reduce((accumulator, currentValue) => {
                let totalSum =
                    accumulator +
                    (currentValue.discount_price ? currentValue.discount_price : currentValue.price) *
                        currentValue.select_count;
                return totalSum;
            }, 0);
        },
    },
    methods: {
        ...mapActions({
            fetchRecommendedList: `recommendedProduct/GET_RECOMMENDED_LIST`,
            fetchPromocode: "basket/SEND_PROMOCODE",
        }),
        ...mapMutations({
            changeShowBasket: `basket/CHANGE_SHOW_BASKET`,
            changeShowOrder: `basket/CHANGE_SHOW_ORDER`,
            remove: `basket/REMOVE_ITEM_FROM_BASKET`,
            decrementBasketItem: `basket/DECREMENT_BASKET_LIST_COUNT`,
            incrementBasketItem: `basket/INCREMENT_BASKET_LIST_COUNT`,
            setBasketItem: `basket/SET_AVAILABILITY_PROPS`,
        }),

        // discountProduct(element) {
        //   if (element.sale_start) {
        //     let period = `${element.sale_start.slice(0, -8)},${element.sale_end.slice(0, -8)}`;
        //     let currentDate = new Date().toISOString().split('T')[0];
        //     let dates = period.split(",");
        //     let result = moment(currentDate).isBetween(dates[0], dates[1], null, '()');
        //     if (result === true) {
        //       return this.showPromo = false
        //     } else {
        //       this.showPromo = true
        //       if (this.enteredCode) {
        //         return this.isValidCode = true
        //       }
        //     }
        //   } else {
        //     if (!this.basket.length) {
        //       this.showPromo = false
        //     }
        //     this.showPromo = true
        //     // return this.isValidCode = true
        //   }
        // },

        // isDiscountPrice() {
        //   this.basket.some(this.discountProduct)
        // },

        sendPromo() {
            this.fetchPromocode(this.codeValue)
                .then(() => {
                    this.isValidCode = true;
                    this.$toasted.success(this.$t("validPromocode"));
                    // this.codeValue = ''
                    localStorage.setItem("useDiscount", this.isValidCode);
                })
                .catch(() => {
                    if (this.promocodeStatus?.status !== 200) {
                        this.$toasted.error(this.$t("errorPromocode"));
                    }
                });
        },
        changeBasket() {
            if (!this.recommendedList) {
                this.fetchRecommendedList();
            }
            this.changeShowBasket(true);
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
        removeItem(item) {
            this.remove(item);
            this.$toasted.success(this.$t("successRemoveBasket"));
        },
        close() {
            if (this.showBasket) {
                this.changeShowBasket(false);
            }
        },
        changeWord(count) {
            let titles = [this.$t("productWord1"), this.$t("productWord2"), this.$t("productWord3")];
            let cases = [2, 0, 1, 1, 1, 2];
            return titles[count % 100 > 4 && count % 100 < 20 ? 2 : cases[count % 10 < 5 ? count % 10 : 5]];
        },
        leftBasket() {
            this.changeShowBasket(false);
        },
        changeOrder() {
            this.changeShowBasket(false);
            this.changeShowOrder(true);
        },
        setCount: _.debounce(function(item, value) {
            this.setBasketItem({
                ...item,
                newCount: value,
            });
        }, 800),
    },
};
